import { render } from "./PhotoViewer.vue?vue&type=template&id=6cb45631&scoped=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=js"
export * from "./PhotoViewer.vue?vue&type=script&lang=js"

import "./PhotoViewer.vue?vue&type=style&index=0&id=6cb45631&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb45631"]])

export default __exports__